import React from 'react';
import { useParams } from 'react-router-dom';

const RedirectToLogin: React.FC = () => {
  const params = useParams();
  const getToken = (stateCode: string | undefined) => {
    switch (stateCode) {
      case 'sc':
        return 'pdP-x1DLd9sjJQD6cxbtseK0wubM3M37hor1Yof_EQc';
      case 'ca':
        return 'V1cA0orcrwI60SJGdkBOwoNeDuSd0v4b6ibjMRICPVI';
      default:
        return 'pdP-x1DLd9sjJQD6cxbtseK0wubM3M37hor1Yof_EQc';
    }
  };

  const token = getToken(params?.stateCode?.toLocaleLowerCase());
  window.location.href =
    '/mathnation/login/preview/registration?registrationToken=' + token;
  return null;
};

export default RedirectToLogin;
